// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2iKJR","rootSuccess":"CompleteLink_rootSuccess__1A_Zp","rootFailure":"CompleteLink_rootFailure__3QlSx","isDisabled":"CompleteLink_isDisabled__FPGMM"};